'use client';

import { c as _c } from "react/compiler-runtime";
import { noop } from 'lodash';
import { type ComponentType, type ReactNode, Suspense, use } from 'react';
const mswPromise = process.env.NEXT_PUBLIC_MOCK_GRAPHQL === '1' && typeof window !== 'undefined' ? import('msw/browser').then(msw => import('@/mocks/apiV4/handlers').then(m => [msw, m.default] as const)).then(([msw, handlers]) => msw.setupWorker(...handlers).start({
  onUnhandledRequest(request, print) {
    if (request.url.includes('_next')) return;
    print.warning();
  }
})).then(noop).catch(console.error) : Promise.resolve();
function WithSuspense<TProps extends {}>(Component: ComponentType<TProps>, fallback: ReactNode = <></>) {
  const WrappedComponent = function WrappedComponent(props) {
    const $ = _c(2);
    let t0;
    if ($[0] !== props) {
      t0 = <Suspense fallback={fallback}><Component {...props} /></Suspense>;
      $[0] = props;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    return t0;
  };
  WrappedComponent.displayName = `${Component.displayName ?? 'Unknown'}WithSuspense`;
  return WrappedComponent;
}
function WithMSWProvider<TProps extends {}>(Component: ComponentType<TProps>) {
  const WrappedComponent = WithSuspense<TProps>(function WrappedComponent(props: TProps) {
    use(mswPromise);
    return <Component {...props} />;
  });
  WrappedComponent.displayName = `${Component.displayName ?? 'Unknown'}WithMSWProvider`;
  return WrappedComponent;
}
export default WithMSWProvider;